function getNameFromPii (pii) {
    return pii.firstName + ' ' + pii.lastName;
}

export default getNameFromPii;